import React from 'react';
import { ErrorMessage, Field } from 'formik';
import { salary } from '../../../constants/formFields/salary';

export const StepThree = () => {
  return (
    <div className=" w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step3">
      <div className="mb-6 form-radio2-main">
        <label className="block text-gray-700 font-medium mb-2">
          Annual income <span>*</span>
        </label>
        <div className="space-y-2">
          {salary.map((ele, i) => {
            const id = `salary_${i}`;
            return (
            <div className="flex items-center form-radio2" key={i}>
              <Field
                type="radio"
                id={id}
                name="salary"
                value={ele.value}
                className="mr-2"
              />
              <label htmlFor={id}>{ele.label}</label>
            </div>
          )})}
          <ErrorMessage name="salary" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
